import ElementHelpers from '../../original/js/libraries/element-helpers';
import { Chat as OrbitBase } from '../../original/js/components/chat';
export class Chat extends OrbitBase {

  /**
   * Add event handlers
   */
  addEventHandlers() {
    this.handleHeaderDivider();
    this.toggleInputButton();
    this.quickSuggestButtonsHandler();
    this.close.addEventListener('click', (event) => {
      this.closeChat(event);
    });
    this.minimized.addEventListener('click', () => {
      this.openChat();
    });
    this.toggleSettingsHandler();
    this.languageSelectorHandler();
    this.popUpHandler();
    this.languageSaveButtonHandler();
    // Removed this.userInputToSpeechBubble();
    this.tagHandler();
    // handle key down event - close modal if escape is pressed
    document.addEventListener('keydown', (keydownEvent) => {
      this.handleButtonKeys(keydownEvent);
    });
  }

  /**
   * Toggles the button from enabled to disabled when typing in the textarea
   */
  toggleInputButton() {
    this.textarea.addEventListener('input', () => {
      if (this.textarea.value.trim().length === 0) {
        this.button.disabled = true;
      } else {
        this.button.disabled = false;
      }
    });
  }

  /**
   * Creates a speech bubbel when clicking on the quick suggestion buttons
   */
   quickSuggestButtonsHandler() {
    // Added these 3 lines, to select newly added elements to the DOM every time this method is called.
    this.quickSuggestButton = ElementHelpers.getElementsByAttribute(
      this.attributes.quickSuggestButton
    );
    if (this.quickSuggestButton) {
      this.quickSuggestButton.forEach(item => {
        item.addEventListener('click', () => {
          const text = item.innerHTML;
          const parentElement = item.parentElement;
          if (!!parentElement) {
            parentElement.removeAttribute(this.attributes.content);
            parentElement.removeAttribute(this.attributes.quickSuggest);
            parentElement.setAttribute(this.attributes.content, 'user');
            parentElement.innerHTML = `<div class="chat__content chat__content--user speech-bubble speech-bubble--user">
            ${text}
          </div>`;
          }

          this.box.scrollTop = this.box.scrollHeight;
        });
      });
    }
  }

  /**
   * Changes the input text to a user speech bubble when clicking on the button
   */
  userInputToSpeechBubble() {
    // Removed addEventListener from the original file.
    // This method is called programmatically from another place.
    const inputText = this.textarea.value;

    // Remove the quickSuggestionButtons if they exist;
    const quickSuggestion = ElementHelpers.getElementByAttribute(
      this.attributes.quickSuggest
    );
    if (quickSuggestion) {
      quickSuggestion.remove();
    }

    // If the last element is from the bot it should add a --first modifier to it
    const box = ElementHelpers.getElementByAttribute(
      this.attributes.box,
      'chat'
    );

    box.innerHTML = box.innerHTML += `<div class='chat-content__wrapper' data-rs-chat-content='user'><div class="chat__content chat__content--user speech-bubble speech-bubble--user">
    ${inputText}</div></div>`;

    if (box.lastElementChild) {
      const islastElementFromBot =
        box.lastElementChild.getAttribute(this.attributes.content) ===
        'bot';

      if (islastElementFromBot) {
        box.lastElementChild.classList.add('chat-content__wrapper--first');
      }
    }

    // Empty the text box
    this.textarea.value = '';
    // Set height back to original'
    this.textarea.style.height = 'auto';

    // Disable the button
    this.button.disabled = true;
    // Scroll to the bottom of the box
    box.scrollTop = box.scrollHeight;
    this.textarea.focus();
  }

  /**
   * Handles the visibility of the tag dialog and content in the dialog when the tags are checked/unchecked
   */
  tagHandler(tags) {
    // Added option to pass tags in order to attach the event listeners for a single reply.
    if (tags) {
      this.tags = ElementHelpers.getElementsByAttributeWithinElement(
        tags,
        this.attributes.tags
      )[0];
    } else {
      this.tags = ElementHelpers.getElementByAttribute(this.attributes.tags);
    }

    if (!this.tags) {
      return;
    }

    const checkboxes = ElementHelpers.getElementsByAttributeWithinElement(
      this.tags,
      'data-rs-tags-checkbox'
    );

    const tagDialogLabel = ElementHelpers.getElementByAttribute(
      this.attributes.tagsDialogLabel
    );

    const label = tagDialogLabel
      ? tagDialogLabel.getAttribute(this.attributes.tagsDialogLabel)
      : '@tag selected';

    for (let i = 0; checkboxes[i]; i++) {
      checkboxes[i].addEventListener('change', (event) => {
        this.getArrayOfSelectedTags(event);

        if (this.amountTagsChecked > 0) {
          this.tagDialog.classList.remove('hidden');
          this.inputDialog.classList.add('hidden');
          this.textarea.setAttribute('aria-hidden', true);
          this.button.setAttribute('aria-hidden', true);
          this.deselectButton.removeAttribute('aria-hidden');
          this.submitButton.removeAttribute('aria-hidden');
          tagDialogLabel.innerText = label.replace(
            '@tag',
            this.amountTagsChecked
          );
        } else {
          this.tagDialog.classList.add('hidden');
          this.inputDialog.classList.remove('hidden');
          this.textarea.removeAttribute('aria-hidden');
          this.button.removeAttribute('aria-hidden');
          this.deselectButton.setAttribute('aria-hidden', true);
          this.submitButton.setAttribute('aria-hidden', true);
        }
      });
    }

    this.handleTagDialogButtons();
  }

  /**
   * Handles the buttons in the tag dialog. Changes the tags that are selected into a user speechbubble, or deselect all checkboxes.
   */
  handleTagDialogButtons() {
    // Deleted eventListener for Submit button.
    const deselectButton = ElementHelpers.getElementByAttribute(
      this.attributes.deselectButton
    );

    const checkboxes = ElementHelpers.getElementsByAttributeWithinElement(
      this.tags,
      'data-rs-tags-checkbox'
    );

    this.deselectButton.addEventListener('click', () => {
      this.tagsChecked = [];
      checkboxes.forEach((item) => {
        if (item.checked) {
          // Fake a click to fire the eventlistener in tag.js
          item.click();
        }
      });
    });
  }

  multiSelectSubmitButton() {
    // EventListener for Submit button converted to method in order to be called from lib scripts.
    const text = this.tagsChecked.join(', ');

    // The content should be user content
    this.tags.setAttribute(this.attributes.content, 'user');

    // The attribute tags should not be there anymore since it's a speech bubble now
    this.tags.removeAttribute(this.attributes.tags);
    this.tags.innerHTML = `<div class="chat__content chat__content--user speech-bubble speech-bubble--user">
          ${text}
        </div>`;

    this.tagDialog.classList.add('hidden');
    this.inputDialog.classList.remove('hidden');
    this.box.scrollTop = this.box.scrollHeight;
    this.submitButton.setAttribute('aria-hidden', true);
    this.deselectButton.setAttribute('aria-hidden', true);
    this.textarea.removeAttribute('aria-hidden');
    this.button.removeAttribute('aria-hidden');
    this.textarea.focus();
  }

  languageSaveButtonHandler() {
    this.saveLanguageButton.addEventListener('click', () => {

      // Next 7 lines are added. Reset all tags before language change.
      const deselectButton = ElementHelpers.getElementByAttribute(
        this.attributes.deselectButton
      );

      if (this.amountTagsChecked > 0) {
        deselectButton.click();
      }

      const box = ElementHelpers.getElementByAttribute(
        this.attributes.box,
        'chat'
      );

      // Empty the box content
      box.innerHTML = '';

      this.openAndCloseSettings();
    });
  }
}
